/************  GESTION DES BLOCS *****************/
var swiperSocial;

jQuery( document ).ready( function( $ ) {
    setupBlocks();
    
    function setupBlocks() {
        initSwiperSlider();
        initBlockMedia();
        initBlockDestination();
        copyToClipboard();
    }
    
    // Fonction pour initialiser les sliders avec Slick
    function initSwiperSlider() {
        if (document.querySelector('.swiper')) {
            document.querySelectorAll(".swiper.mobileonly").forEach(function (element) {
                const swiperMargin = new Swiper(element, {
                    pagination: {
                        el: element.querySelector('.slidebullets'),
                        clickable: true
                    },
                    navigation: {
                        nextEl: element.querySelector('.button-next'),
                        prevEl: element.querySelector('.button-prev')
                    },
                    spaceBetween: 24,
                    slidesPerView: 'auto'
                });
            });
            
            document.querySelectorAll(".swiper:not(.mobileonly)").forEach(function (element) {
                let params = {
                    pagination: {
                        el: element.querySelector('.slidebullets'),
                        clickable: true
                    },
                    navigation: {
                        nextEl: element.querySelector('.button-next'),
                        prevEl: element.querySelector('.button-prev')
                    },
                    spaceBetween: 32,
                    slidesPerView: 'auto'
                };
                if(element.classList.contains('lessMargin')) {
                    params.spaceBetween = 24;
                    params.breakpoints = {
                        1000: {
                            spaceBetween: 32
                        }
                    }
                }
                const swiperMargin = new Swiper(element, params);
            });
        }
    }
    
    // Fonction qui permet de lire une vidéo
    function initBlockMedia() {
        $('.blocktextimg-media.has-video, .blockmedia-media.has-video').click(function() {
            if(!$(this).hasClass('showVideo')) {
                $(this).addClass('showVideo');
                // Lecture des vidéos Youtube et Vimeo
                let videoUrl = $(this).find("iframe").attr('src');
                $(this).find(".video_player iframe").attr('allow', 'autoplay; fullscreen');
                if(videoUrl.split('?').length > 0) videoUrl = videoUrl.split('?')[0]
                $(this).find(".youtube_player iframe").attr('src', videoUrl + '?theme=light&rel=0&controls=1&enablejsapi=1&showinfo=0&autoplay=1');
            }
        });
    }
    
    // Fonction pour afficher les destinations
    function initBlockDestination() {
        $('.blockdestination .thumbnails-item').click(function() {
            if(!$(this).hasClass('active')) {
                $('.blockdestination .thumbnails-item.active').removeClass('active');
                $(this).addClass('active');
                $(this).parent().parent().find('.mainimage img').remove();
                $(this).parent().parent().find('.mainimage').append($(this).find('img').clone());
                $(this).parent().parent().find('.maintext').html($(this).next().html());
            }
        });
    }
    
    function copyToClipboard() {
        $( '.social-share' ).on( 'click', async function () {
            const btn = $( this );
            const url = window.location.href;
            
            await navigator.clipboard.writeText(url);
            
            btn.parent().find('.tooltip').addClass('copied');
            setTimeout(function() { $('.copied').removeClass('copied'); }, 1800);
        });
    }
});